import React from 'react';
import ReactDOM from 'react-dom/client';
import { ConfigProvider, Spin } from 'antd';
import App from './App';
import { appTheme } from './theme/appTheme';
import './i18n';
import reportWebVitals from './reportWebVitals';
import "./index.css";
import GearSpinner from './components/GearSpinner';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

// Replaces antd's default rotating-dot indicator with the app's own turning
// gear everywhere a plain <Spin> is used (fullscreen page loaders, inline
// small spinners, <Spin spinning> overlays) -- one switch instead of
// touching every individual call site. Explicit `indicator` props (there
// are none today) still take precedence, same as any other antd default.
Spin.setDefaultIndicator(<GearSpinner />);

root.render(
  <ConfigProvider theme={appTheme}>
    <App />
  </ConfigProvider>
);

reportWebVitals();

